import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PlayDisabledIcon(props: IconProps) {
    return <Icon {...props} iconKey={"play_disabled"}/>
}
